/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'guanzhang-1': {
    sides: [
      { f: 'shu', n: '劉備', l: '張飛（與諸葛亮、趙雲溯江西上）', w: 1 },
      { f: 'lz', n: '劉璋', l: '巴郡太守嚴顏' },
    ],
    before: '劉備入蜀後和劉璋翻臉，在雒城久攻不下。諸葛亮、張飛、趙雲從荊州帶兵溯江而上，平定白帝、江州、江陽，只留關羽鎮守荊州。江州的守將是巴郡太守嚴顏。',
    after: '張飛破江州、生擒嚴顏。嚴顏說「我州但有斷頭將軍，無有降將軍」，張飛佩服他的氣節，放了他並待為賓客。之後張飛沿路攻克各地，在成都與劉備會師。',
    src: '《三國志·蜀書·張飛傳》；〈先主傳〉；嚴顏「獨坐窮山，放虎自衛」的嘆息見裴注引《華陽國志》',
  },
  'guanzhang-2': {
    sides: [
      { f: 'shu', n: '劉備', l: '巴西太守張飛', w: 1 },
      { f: 'wei', n: '曹操', l: '張郃（夏侯淵督漢中）' },
    ],
    before: '曹操平定漢中，張魯投降，留夏侯淵、張郃守漢川。張郃另外帶兵南下巴西，想把當地百姓遷到漢中，進軍宕渠、蒙頭、蕩石，和張飛相持了五十多天。',
    after: '張飛帶精兵一萬多人從別的路截擊，山路狹窄，張郃軍前後不能相救，大敗。張郃丟下馬爬山，只帶十幾個人從小路逃回南鄭，巴西得以安定。',
    src: '《三國志·蜀書·張飛傳》；〈魏書·張郃傳〉',
  },
  'guanzhang-3': {
    sides: [
      { f: 'shu', n: '關羽', l: '董督荊州事' },
    ],
    before: '劉備西定益州後，拜關羽董督荊州事。關羽早年左臂被流矢射穿，傷口雖然好了，每逢陰雨骨頭仍然疼痛。醫生說箭頭有毒、毒入骨中，要劃開手臂刮骨去毒。史書沒寫是哪一年，也沒留下醫生的名字。',
    after: '關羽伸臂讓醫生劈開，當時正請諸將飲食，血流滿盤，他照樣割肉飲酒、談笑自若。',
    src: '《三國志·蜀書·關羽傳》',
  },
  'guanzhang-4': {
    sides: [
      { f: 'shu', n: '劉備', l: '前將軍關羽', w: 1 },
      { f: 'wei', n: '曹操', l: '曹仁（守樊城）、于禁、龐德' },
    ],
    before: '建安二十四年劉備取漢中、稱漢中王，拜關羽為前將軍。同年關羽北攻樊城的曹仁，曹操派于禁督七軍救援，龐德屯在樊城北邊。龐德曾親自和關羽交戰，射中關羽的額頭。',
    after: '秋天連下大雨，漢水暴漲，于禁七軍都被淹沒，于禁登高望水無處可逃，向乘大船來攻的關羽投降。龐德在堤上死戰到箭盡，乘小船想回樊城，船翻被擒，不肯投降而被殺。關羽威震華夏，曹操一度商議遷都避其鋒芒。',
    src: '《三國志·蜀書·關羽傳》；〈魏書·于禁傳〉〈龐德傳〉',
  },
  'guanzhang-5': {
    sides: [
      { f: 'wu', n: '孫權', l: '呂蒙、朱然、潘璋', w: 1 },
      { f: 'shu', n: '劉備', l: '關羽、關平、趙累' },
    ],
    before: '曹操派徐晃救樊城，關羽攻不下而退兵。這時孫權已派呂蒙襲取公安、江陵，關羽將士的家眷都落入吳軍手中。呂蒙厚待關羽派來的使者，使者回去說家裡平安、待遇比平時還好，關羽的兵從此沒了鬥志。',
    after: '關羽退保麥城，假裝投降，在城頭立旗和假人後逃走，身邊只剩十幾騎。孫權早派朱然、潘璋截斷去路，十二月潘璋的司馬馬忠在章鄉擒獲關羽父子與趙累，關羽被斬，荊州歸吳。兩年後張飛也被部將張達、范彊殺害。',
    src: '《三國志·吳書·吳主傳》〈呂蒙傳〉；〈蜀書·關羽傳〉〈張飛傳〉',
  },
};
